import React from 'react';

export default class DistributionTooltip extends React.PureComponent {
  render() {
    const {teamSize, membersCoached, user} = this.props;
    if (teamSize === 0 || membersCoached === 0) {
      return (
        <div className="distribution-content">
          {user.getFullName()} did no coaching in this period.
        </div>
      );
    }

    const plural = teamSize > 1;
    const excess =
      membersCoached > teamSize
        ? '(This indicates that members of the team left within the date range being reported on.)'
        : '';
    return (
      <div className="distribution-content">
        {user.getFullName()} coached {membersCoached} out of {teamSize} rep
        {plural && 's'} on the team in this period. {excess}
      </div>
    );
  }
}
